import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import { getProjects } from "../../services/api";
import {getNowReadyConfigurationsForAccount} from "../../services/backendApi";
import Spinner from "../presentation/spinner";
import "./style.css";

export default ({ id }) => {
  const [error, setError] = useState();
  const [projects, setProjects] = useState(null);
  const [projectsWithConfigs, setProjectsWithConfigs] = useState([]);

  useEffect(() => {
    const loadProjectsFromServer = async (accountId) => {
      const accessToken = localStorage.getItem("idToken");
      try {
        const projects = await getProjects(accountId, accessToken);
        setProjects(projects);
      } catch (error) {
        console.error(error);
        setError("An error occurred retrieving projects");
      }
    };
    if (!id) {
      setError("Invalid URL. AccountId not found");
      return;
    }
    loadProjectsFromServer(id);
  }, [id]);

  useEffect(() => {
    const getSavedConfigurations = async (accountId) => {
      try {
        const savedConfigurations = await getNowReadyConfigurationsForAccount(accountId);
        const projectIdsWithConfiguration = savedConfigurations.map(configuration => configuration.projectId)
        setProjectsWithConfigs(projectIdsWithConfiguration)
      } catch (error) {
        console.error(error);
        setError("An error occurred retrieving saved configurations");
      }
    };
    if (!id) {
      setError("Invalid URL. AccountId not found");
      return;
    }
    getSavedConfigurations(id);
  }, [id]);

  const renderProjectRows = (projects, error, projectsWithConfigs) => {
    if (error) {
      return (
          <div className="project-list-message">
            <h2>{error}</h2>
          </div>
      );
    }
    if (!projects || !projectsWithConfigs) {
      return (
        <div className="project-list-message">
          <Spinner size="150" />
          <h2>Retrieving Projects</h2>
        </div>
      );
    }
    if (projects.length) {
      return (
        <table className="customer-projects-table">
          <thead>
            <tr>
              <th>Name</th>
              <th className="nowready-configure-column"></th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => (
              <tr key={project._id}>
                <td>{project.name}</td>
                <td>
                  {projectsWithConfigs.includes(project._id) ? <Link to={`/customer/${id}/nowReady/${project._id}`}>Configure</Link> : "No Configuration Found"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    if (projects.length === 0) {
      return <h2>No projects found for this account</h2>;
    }
  };

  return (
    <div>
      <label className="box-label">
        Configure Super User Settings For Now Ready Screens
      </label>
      <div className="project-list-explanation">
        <p>Now Ready Branding is now managed via Canvas. To manage Now Ready branding via Canvas, please ensure that the Now Ready Configuration feature
          is enabled for the target account.</p>
        <p>
          Once Now Ready branding has been configured for a target project via Canvas, certain settings that are not available via Canvas can be configured via this
          page, namely the ability to disable the On The Way flow for Now Ready Screens, and adjusting the registration time to live value, which determines the expiry time
          of orders in Hello Screens.
          </p>
          <p>
            If custom registration time to live values are not set, the default value of 24 hours is used.
          </p>
      </div>

      {renderProjectRows(projects, error, projectsWithConfigs)}
    </div>
  );
};
